import React, { useRef, useState, useEffect  } from 'react';
import './index.module.less';

import { defaultPoint } from '@helpers/Constants';
import { Api } from '@apis/client';
import Http from '@helpers/Http';
import Filter from '@helpers/Filter';
import { transformToBd09 } from '@utils/mapUtil';

import NavBar from '@components/NavBar';
// import BaseMap  from '@components/map/BaseMap';
import BaseMap, { CustomOverlay } from '@components/map/Map/BaseMap';

import Card from './Card';
import defaultAvatar from '@images/avatar_default.png';

const LocationRecord = () => {
  const params = useRef(Filter.urlParams(window.location.search));
  const mapRef = useRef(null);
  const [center, setMapCenter] = useState(defaultPoint);
  const [recordInfo, setRecordInfo] = useState(null);
  const mapLoaded = useRef(false);
  const recordDetail = useRef(null);

  const getRecordInfo = async () => {
    const { data: result } = await Http.post(
      Api.GetGuardRecord,
      { uid: params.current?.recordId },
      { noLoading: true }
    )
    if(result) {
      transferPosition(result);
    }
  }

  const onMapLoad = () => {
    console.log('load map 1');
    mapLoaded.current = true;
    if(recordInfo || recordDetail.current) {
      const positionResult = recordInfo || recordDetail.current;
      const position = JSON.parse(positionResult.position);
      const tempCenter = transformToBd09({ lng: position.longitude, lat: position.latitude });
      const instanceMap = mapRef.current;
      setTimeout(() => {
        instanceMap.setCenter(tempCenter);
        setMapCenter(tempCenter);
      }, 50)
      console.log('info 333');

    }else {
      console.log('info 111');
      getRecordInfo();
    }
  }

  useEffect(() => {
    //在ios app 内会出现地图onload 事件没有触发，处理方式：
    //如果地图onload 事件已触发且当前没有获取数据，那就直接请求数据
    //如果onload 事件在3s后都还没有触发，大概率不会触发了，此时手动请求数据
    setTimeout(() => {
      if(!mapLoaded.current) {
        console.log('info 222');
        getRecordInfo();
      }
    }, 3000)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  //地址解析
  const transferPosition = async (data: any) => {
    if(data.position) {
      const position = JSON.parse(data.position);
      let condition = data;
      if(position.locationName) {
        condition = { ...data, address: position.locationName }
      }else {
        const res = await mapRef.current?.getLocation(defaultPoint || {lng: position.longitude, lat: position.latitude} );
        condition= { ...data, address: (res.address || '') +  (res.title || '')}
      }
      setRecordInfo(condition);
      recordDetail.current = condition;
      const instanceMap = mapRef.current;
      const tempCenter = { lng: position.longitude, lat: position.latitude };
      instanceMap.setCenter(tempCenter);
      setMapCenter(tempCenter);
    }
  }
  return (
    <div style={{ width: '100%', height: document.body.clientHeight }}>
      <NavBar title=" " transparent />
      <BaseMap ref={ mapRef } center={ center } zoom={ 18 } onMapLoad={ onMapLoad }>
        {
          recordInfo ? (
            <CustomOverlay position={center}>
              <div styleName="avatar-wrapper">
                <div styleName="avatar">
                  <img
                    styleName="avatar-img"
                    src={ recordInfo?.recordUser?.picUrl || defaultAvatar} alt=""
                  />
                </div>
              </div>
            </CustomOverlay>
          ) : null
        }
      </BaseMap>
      { recordInfo ? <Card recordInfo={ recordInfo } /> : null }
    </div>
  )
}

export default LocationRecord;